export default __webpack_public_path__ + "static/media/notio-logo.74d0b1a4.svg";